<div class="validation-container">
  <ul>
    <li *ngFor="let message of messages">{{ message }}</li>
  </ul>
</div>
